"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedLanguageDtoMinTierEnum = void 0;
exports.instanceOfSelectedLanguageDto = instanceOfSelectedLanguageDto;
exports.SelectedLanguageDtoFromJSON = SelectedLanguageDtoFromJSON;
exports.SelectedLanguageDtoFromJSONTyped = SelectedLanguageDtoFromJSONTyped;
exports.SelectedLanguageDtoToJSON = SelectedLanguageDtoToJSON;
exports.SelectedLanguageDtoToJSONTyped = SelectedLanguageDtoToJSONTyped;
/**
 * @export
 */
exports.SelectedLanguageDtoMinTierEnum = {
    Free: 'free',
    Pro: 'pro',
    Champion: 'champion'
};
/**
 * Check if a given object implements the SelectedLanguageDto interface.
 */
function instanceOfSelectedLanguageDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('englishName' in value) || value['englishName'] === undefined)
        return false;
    if (!('nativeName' in value) || value['nativeName'] === undefined)
        return false;
    if (!('minTier' in value) || value['minTier'] === undefined)
        return false;
    return true;
}
function SelectedLanguageDtoFromJSON(json) {
    return SelectedLanguageDtoFromJSONTyped(json, false);
}
function SelectedLanguageDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'code': json['code'],
        'englishName': json['englishName'],
        'nativeName': json['nativeName'],
        'minTier': json['minTier'],
    };
}
function SelectedLanguageDtoToJSON(json) {
    return SelectedLanguageDtoToJSONTyped(json, false);
}
function SelectedLanguageDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'code': value['code'],
        'englishName': value['englishName'],
        'nativeName': value['nativeName'],
        'minTier': value['minTier'],
    };
}
